import React, { useEffect, useState } from 'react';

// <img> that walks through `sources` (primary first) when one fails to load —
// a hosted photo can disappear after we indexed it — and calls onExhausted
// when none of them render.
export default function FallbackImg({ sources, onExhausted, alt = '', ...imgProps }) {
  const list = (Array.isArray(sources) ? sources : [sources]).filter(Boolean);
  const key = list.join('\n');
  const [idx, setIdx] = useState(0);
  useEffect(() => { setIdx(0); }, [key]);

  useEffect(() => {
    if (idx >= list.length) onExhausted?.();
  }, [idx, list.length, onExhausted]);

  if (idx >= list.length) return null;
  return <img {...imgProps} alt={alt} src={list[idx]} onError={() => setIdx(i => i + 1)} />;
}

// Fills its positioned parent with one sharp photo, cropped to cover the slot.
export function FullPhoto({ sources, alt = '', onExhausted }) {
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <FallbackImg sources={sources} alt={alt} onExhausted={onExhausted}
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center 35%', display: 'block' }} />
    </div>
  );
}

// A single photo that gives way to `fallback` (e.g. a category emoji) when the URL is
// missing or no longer loads.
export function ImgOrFallback({ src, fallback = null, alt = '', ...imgProps }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [src]);
  if (!src || failed) return fallback;
  return <img {...imgProps} alt={alt} src={src} onError={() => setFailed(true)} />;
}
